import User from '@/views/user/User';
import Login from '@/views/user/Login';
import Logout from '@/views/user/Logout';
import RequestPasswordReset from '@/views/user/RequestPasswordReset';
import ResetPassword from '@/views/user/ResetPassword';
import { loginLayout } from '../layout';
import { loggedInRedirect } from '../guards';

export default [
  {
    path: '/user',
    name: 'User',
    components: {
      default: User,
      ...loginLayout,
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        components: {
          default: Login,
        },
        beforeEnter: loggedInRedirect,
      },
      {
        path: 'reset-password/',
        name: 'RequestPasswordReset',
        components: {
          default: RequestPasswordReset,
        },
      },
      {
        path: ':uid/:token/reset-password/',
        name: 'ResetPassword',
        components: {
          default: ResetPassword,
        },
      },
      {
        path: 'logout',
        name: 'Logout',
        components: {
          default: Logout,
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/user.js